import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Radio, RadioGroup, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayToggleItem = ({
  register,
  icon,
  onChange,
  tc = /** @type {any} */ (undefined),
  options,
  inhibitText = false,
  disabled,
  borderOff = false,
}) => {
  const [value, setValue] = useState(register.value);

  const updateValue = (value) => {
    setValue(value);
    devLog('toggled', value);
    onChange(register, value);
  };

  useEffect(() => {
    setValue(register.value);
  }, [register.value]);
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4 ">
        <DisplayIcon icon={icon} />
        {!inhibitText ? (
          <div className="truncate space-y-1 w-1/2">
            <Text color={tc} className="truncate">
              {register.title}
            </Text>
            <Text color={tc} className="truncate">
              <Bold>{register.display}</Bold>
            </Text>{' '}
          </div>
        ) : (
          ' '
        )}
        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <RadioGroup
              name={`radioList-${register.address}`}
              inline
              appearance="picker"
              onChange={updateValue}
              value={value}
            >
              {options.map((item) => (
                <Radio key={item.value + 1} value={item.value} disabled={disabled}>
                  {' '}
                  {item.label}{' '}
                </Radio>
              ))}
            </RadioGroup>
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
